module.exports = __webpack_public_path__ + "static/media/mini-avatar.eabcd159.svg";